import React from 'react';
import { createRoot } from 'react-dom/client';
import WelcomeOfferModal from './welcome-offer-modal';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(<WelcomeOfferModal {...data} />);
  };

  init();
};
